export default {
    cn: {
        clientReport: {
            downloadName: '客户报表',
            enableMapper: { 0: '禁用', 1: '启用' },
            loadText: '正在下载,请稍候...',
            tableHead: [
                { key: 'LOGIN', value: '账号' },
                { key: 'GROUP', value: '组别' },
                { key: 'CURRENCY', value: '入金货币' },
                { key: 'enable', value: '启用/禁用' },
                { key: 'NAME', value: '名字' },
                { key: 'EMAIL', value: '电邮' },
                { key: 'PHONE', value: '电话' },
                { key: 'ADDRESS', value: '地址' },
                { key: 'REGDATE', value: '注册日期' },
                { key: 'LEVERAGE', value: '杠杆' },
                // { key: 'LAST_TRADE_DATE', value: '最后交易时间' }
            ]
        }
    },
    hk: {
        clientReport: {
            downloadName: '客戶報表',
            enableMapper: { 0: '禁用', 1: '啟用' },
            loadText: '正在下載,請稍候...',
            tableHead: [
                { key: 'LOGIN', value: '賬戶' },
                { key: 'GROUP', value: '組別' },
                { key: 'CURRENCY', value: '入金貨幣' },
                { key: 'enable', value: '啟用/禁用' },
                { key: 'NAME', value: '名字' },
                { key: 'EMAIL', value: '電郵' },
                { key: 'PHONE', value: '電話' },
                { key: 'ADDRESS', value: '地址' },
                { key: 'REGDATE', value: '註冊日期' },
                { key: 'LEVERAGE', value: '槓桿' },
                // { key: 'LAST_TRADE_DATE', value: '最後交易時間' }
            ]
        }
    },
    en: {
        clientReport: {
            downloadName: 'Client Report',
            enableMapper: { 0: 'Disable', 1: 'Enable' },
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [
                { key: 'LOGIN', value: 'Login' },
                { key: 'GROUP', value: 'Group' },
                { key: 'CURRENCY', value: 'Currency' },
                { key: 'enable', value: 'Enable' },
                { key: 'NAME', value: 'Name' },
                { key: 'EMAIL', value: 'Email' },
                { key: 'PHONE', value: 'Phone' },
                { key: 'ADDRESS', value: 'Address' },
                { key: 'REGDATE', value: 'Regdate' },
                { key: 'LEVERAGE', value: 'Leverage' },
                // { key: 'LAST_TRADE_DATE', value: 'Last Trade Date' }
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/report/clientReport.js